import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
import { setPrimaryTracker } from 'usage-tracker-container';
export const usageTracker = createTracker({
  events
});

/**
 * This sets up the primary usage tracker for reporting's PlatformReportResolver.
 *
 * To avoid importing extra dependencies we're using the string 'reporting-tracker' as the
 * tracker name, which is typically denoted by the REPORTING_TRACKER constant in reporting-data:
 *
 * https://git.hubteam.com/HubSpot/reporting/blob/cf918f2845f59101519be3005e495890cc7acdef/reporting-data/static/js/constants/usageTracker.ts#L1
 */

setPrimaryTracker(usageTracker, 'reporting-tracker');